import { useTranslation } from 'react-i18next';

import './LanguageBox.scss';
import useStore from '@/stores/useStore';
import { useEffect, useState } from 'react';

const LanguageBox = () => {
    const { i18n } = useTranslation();

    const handleLangSelect = (e: any) => {
        i18n.changeLanguage(e.target.value);
    };

    const [languages, setLanguages] = useState<any>(null);

    const data = useStore((state) => state.data);

    useEffect(() => {
        if (languages && languages.length > 0) return;
        if (data && data.languages) {
            setLanguages(() => data.languages);
        }
        if (data?.languages[0] === 'en' || data?.languages[0] === 'fr') {
            setTimeout(() => {
                i18n.changeLanguage(
                    data.languages.indexOf(i18n.language.split('-')[0]) >= 0
                        ? i18n.language.split('-')[0]
                        : data.languages[0]
                );
            }, 0);
        }
    }, [data]);

    return (
        <div
            className={`language-box ${
                data?.languages.length === 1 ? 'language-box_hidden' : ''
            }`}
        >
            <select
                onChange={(e) => handleLangSelect(e)}
                value={i18n.language.split('-')[0]}
            >
                {languages?.map((language: any, idx: number) => {
                    return (
                        <option value={language} key={idx}>
                            {language}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default LanguageBox;
